import React from 'react';
import Text from 'Components/Text';
import { Input, inputStyleClasses } from 'Components/Input';

export default ({ type, category, name, inputErrors, handleInputChange }) => {
  return (
    <section className='scene_section'>
      <header>General Information</header>
      <Input
        mainWrapperClassName='_width_pc_100'
        styleClass={inputStyleClasses.primary}
        label='Component Family Name *'
        maxLength={250}
        alwaysTextField
        error={inputErrors.name}
        value={name}
        onChange={handleInputChange('name')}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary  _margin_right_30'
        textClassName='text__text_primary'
        label='Component Category'
        value={category.name}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary'
        textClassName='text__text_primary'
        label='Component Type'
        value={type.componentTypeName}
      />
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/ComponentFamily/Edit/GeneralInformation.jsx